import axios from 'axios';
import {type ActionTree} from 'vuex';

const actions: ActionTree<ModuleInstallerState, RootState> = {
    fetch({commit, state})
    {
        if (state.isFetched)
        {
            return Promise.resolve();
        }

        if (state.fetch)
        {
            return state.fetch;
        }

        const promise = axios.get('/installer/index/fetch-data').then(({data: {data}}) => {
            commit('update', Object.assign(data, {fetch: null, isFetched: true}));
        });

        commit('update', {fetch: promise});

        return promise;
    },
};

export default actions;